"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addParamsToUrlString = exports.addParamsToUrl = void 0;
const query_string_1 = require("query-string");
const addParamsToUrl = (params) => {
    const url = (0, query_string_1.parseUrl)(window.location.href, { arrayFormat: "bracket" });
    const newParams = Object.assign(Object.assign({}, url.query), params);
    const paramStr = buildParamString(newParams);
    return `${url.url}?${paramStr}${window.location.hash}`;
};
exports.addParamsToUrl = addParamsToUrl;
const addParamsToUrlString = (url, params) => {
    const paramStr = buildParamString(params);
    if (!url.includes("?")) {
        url = `${url}?`;
    }
    return `${url}${paramStr}`;
};
exports.addParamsToUrlString = addParamsToUrlString;
const buildParamString = (params) => Object.keys(params)
    .map(k => Array.isArray(params[k])
    ? (0, query_string_1.stringify)({ [k]: params[k] }, { arrayFormat: "bracket" })
    : `${k}=${params[k] !== undefined
        ? encodeURIComponent(params[k])
        : ""}`)
    .join("&");
//# sourceMappingURL=addParamsToUrl.js.map